import type { FC, ReactNode } from "react";

import { useDropdownQuickAdd } from "@ryde/redux";
import type { IDropdownItem, IFormAttributes } from "@ryde/shared";

import { QuickAddStationForm } from "./quick-add-station";
import { useQuickAddStation } from "./quick-add-station/use-quick-add-station";

interface IDropdownBoundQuickAddFlowMapProps {
  name: string;
  formAttributes?: IFormAttributes | null;
  fetchItems: (forceRefetch?: boolean) => Promise<IDropdownItem[] | undefined>;
}

export const DropdownBoundQuickAddFlowMap: FC<
  IDropdownBoundQuickAddFlowMapProps
> = ({ name, formAttributes, fetchItems }): ReactNode | null => {
  const { closeQuickAdd } = useDropdownQuickAdd({
    entity: formAttributes?.dropItemsSource,
    name,
  });

  const { onSave } = useQuickAddStation({
    name,
    formAttributes,
    closeQuickAdd,
    fetchItems,
  });

  if (!formAttributes?.dropItemsSource) {
    return null;
  }

  switch (formAttributes.dropItemsSource) {
    case "station":
      return (
        <QuickAddStationForm onSave={onSave} closeQuickAdd={closeQuickAdd} />
      );
    default:
      return null;
  }
};
